/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Schoolname_Taunusgymnasium2Inputs */

const en__field__enum_schoolname_taunusgymnasium2 = /** @type {(inputs: _Field__Enum_Schoolname_Taunusgymnasium2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Königstein`)
};

const de__field__enum_schoolname_taunusgymnasium2 = /** @type {(inputs: _Field__Enum_Schoolname_Taunusgymnasium2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taunusgymnasium`)
};

/**
* | output |
* | --- |
* | "Königstein" |
*
* @param {_Field__Enum_Schoolname_Taunusgymnasium2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_schoolname_taunusgymnasium2 = /** @type {((inputs?: _Field__Enum_Schoolname_Taunusgymnasium2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Schoolname_Taunusgymnasium2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_schoolname_taunusgymnasium2(inputs)
	return de__field__enum_schoolname_taunusgymnasium2(inputs)
});
export { _field__enum_schoolname_taunusgymnasium2 as "_field__enum_schoolName_Taunusgymnasium" }